import API from 'services/API';

export default function getCalendarYears() {
  return API.request({
    method: 'GET',
    url: '/calendarEvent/years',
  });
}
